import React, { useState } from 'react';
import { Card, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

const RegistrationSuccess = ({ email, onSwitchToLogin }) => {
  const { resendVerification } = useAuth();
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResendEmail = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await resendVerification(email);
      setMessage(t('registrationSuccess.emailResent'));
    } catch (err) {
      const errorText = err.data?.errorText;
      if (typeof errorText === 'string') {
        setError(errorText);
      } else if (typeof errorText === 'object') {
        const messages = Object.values(errorText).flat();
        setError(messages.join(' '));
      } else {
        setError(t('registrationSuccess.resendFailed'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="auth-card" style={{ maxWidth: '450px', width: '100%' }}>
      <Card.Body className="p-4 p-md-5 text-center">
        <div className="icon-circle bg-info bg-gradient mx-auto mb-3">
          <i className="bi bi-envelope-check text-white"></i>
        </div>
        <h2 className="fw-bold">{t('registrationSuccess.title')}</h2>
        <p className="text-muted">{t('registrationSuccess.message')}</p>
        <p className="text-primary fw-semibold mb-4">{email}</p>

        <Alert variant="warning" className="text-start">
          <div className="d-flex">
            <i className="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
            <div>
              <strong>{t('registrationSuccess.important')}</strong> {t('registrationSuccess.info')}
            </div>
          </div>
        </Alert>

        {message && <Alert variant="success">{message}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}

        <p className="text-muted mb-3">{t('registrationSuccess.didntReceiveEmail')}</p>
        <Button
          variant="outline-primary"
          className="w-100 mb-4"
          onClick={handleResendEmail}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              {t('registrationSuccess.sending')}
            </>
          ) : (
            <>
              <i className="bi bi-arrow-repeat me-2"></i>
              {t('registrationSuccess.resendButton')}
            </>
          )}
        </Button>

        <hr className="my-4" />

        <p className="mb-0">
          {t('registrationSuccess.alreadyVerified')}{' '}
          <Button variant="link" className="p-0 link-primary" onClick={onSwitchToLogin}>
            {t('registrationSuccess.signIn')}
          </Button>
        </p>
      </Card.Body>
    </Card>
  );
};

export default RegistrationSuccess;
